import { render } from "./wfm-calendar.vue?vue&type=template&id=3ba54ec3"
import script from "./wfm-calendar.vue?vue&type=script&lang=js"
export * from "./wfm-calendar.vue?vue&type=script&lang=js"

import "./wfm-calendar.vue?vue&type=style&index=0&id=3ba54ec3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__